export const environment = {
  production: true,
  baseUrl: 'https://raterhelperv3.herokuapp.com'
};
